<template>
  <div class="Search clear-fix">
    <div class="Search-input" v-for="item in option">
      <a-input :placeholder="item.placeholder" v-model="item[item.name]">
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>
    <a-button class="search-btn"  @click="searchClick">搜索</a-button>
  </div>
</template>

<script>

export default {
  name: "Search",
  props: {
    option: {
      type: Array,
      default() {
        return [{
          placeholder:"请输入搜索内容",
          name:"",
        }]
      }
    }
  },
  data() {
    return {
      searchText: ''
    }
  },
  methods: {
    searchClick() {
      this.$emit("onSearch", this.option)
    }
  }
}
</script>

<style lang="scss" scoped>
  .Search {
    .Search-input {
      width: 250px;
      margin: 0 15px 0 0px;
      float: left;
    }
    .search-btn {
      float: left;
      color: #fff;
      background-color:rgba($color: #E84D11, $alpha: .6)
    }
  }

</style>
